module.exports = __webpack_public_path__ + "/static/assets/49977a0d3680d3a72955df57e5a15afb.svg";